import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';
import { InsuranceAgreementDetail, SubscriptionRequest, SubscriptionResponse, UpdateSubscriptionRequest } from '../service/store/subscription-state';

export interface ISubscriptionProcessApi {
  createSubscription(subscriptionRequest: SubscriptionRequest): Promise<APIResponse<SubscriptionResponse>>;
  createSubscriptionWithRecaptcha(subscriptionRequest: SubscriptionRequest, reCaptchaValue: string): Promise<APIResponse<SubscriptionResponse>>;
  updateSubscription(subscriptionId: string, updateRequest: Partial<SubscriptionRequest>): Promise<APIResponse<InsuranceAgreementDetail>>;
  getSubscription(subscriptionId: string): Promise<APIResponse<InsuranceAgreementDetail>>;
  signDocuments(subscriptionId: string, signRequest: any): Promise<APIResponse<any>>
}

// services/subscriptionApi.ts
export class SubscriptionProcessApi {
  async createSubscription(subscriptionRequest: SubscriptionRequest): Promise<APIResponse<SubscriptionResponse>> {
    return returnAxios(axios.post('/journey/subscriptions', subscriptionRequest));
  }

  async createSubscriptionWithRecaptcha(
    subscriptionRequest: SubscriptionRequest,
    reCaptchaValue: string
  ): Promise<APIResponse<SubscriptionResponse>> {
    return returnAxios(axios.post(`/journey/subscriptions?reCaptchaValue=${reCaptchaValue}`, subscriptionRequest));
  }

  async updateSubscription(
    subscriptionId: string,
    updateRequest: Partial<UpdateSubscriptionRequest>,
    token: string
  ): Promise<APIResponse<InsuranceAgreementDetail>> {
    return returnAxios(axios.put(`/journey/subscriptions/${subscriptionId}`, updateRequest, {
      headers: {
        'X-Subscription-Token': token
      }
    }));
  }

  async getSubscription(subscriptionId: string, token: string): Promise<APIResponse<InsuranceAgreementDetail>> {
    return returnAxios(axios.get(`/journey/subscriptions/${subscriptionId}`, {
      headers: {
        'X-Subscription-Token': token
      }
    }));
  }

  async signDocuments(subscriptionId: string, signRequest: any): Promise<APIResponse<any>> {
    return returnAxios(axios.post(`/journey/subscriptions/${subscriptionId}/sign-documents`, signRequest));
  }

  async validateSubscription(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get('journey/validation-transmit/' + subscriptionNumber));
  }

}